import styled from 'styled-components';
import {  Button } from 'react-bootstrap';

/*********** this is Styles for Header Component *********/

export const MyHeader = styled.header`
    height:calc(100vh - 60px);
    background-color: #EFF0EA;
    display: flex;
    justify-content: center;
    align-items: center;
    position:relative;
    background-image: url(${props =>props.bg});
    background-size: cover;
    background-blend-mode: multiply;
    background-color: #494a4bf2;
`;

export const HeadrtText = styled.div`
    text-align: center;
    padding: 0px 20px;
    h1{
        font-size: 50px;
        font-weight: 600;
        text-transform: capitalize;
        color: white;
        @media (max-width:593px){
            font-size: 34px;
         }

        span{
         color: var(--primaryColor);
        }
    }
    p{
        color: #ddd8d8;
        text-align: center;
        padding: 2px;
        max-width: 880px;
        margin-bottom:20px;
        @media (max-width:593px){
            font-size: 14px;
        }
    }
`;

export const Btn1 = styled(Button)`
    background-color: var(--primaryColor);
    border-color: var(--primaryColor);
    padding: 7px 21px;
    margin-right: 10px;
`;
export const Btn2 = styled(Button)`
    background-color: white;
    border-color: var(--primaryColor);
    padding: 7px 21px;
    color:black;
`;

/*********** this is Styles for Header Component *********/
